import React from 'react';
import ReportTemplateModel, { ReportTemplateModelNames } from './ReportTemplateModel';

const TemplateReportsList = () => {
    return (
        <ReportTemplateModel
            modelName={ReportTemplateModelNames.Report}
        />
    );
}
export default React.memo(TemplateReportsList);
